// FUNCTION TO CONTROL DROPDOWNS ONLY IN NAVBAR MENUS
export function showNavbarDropdown(dropdown, content, index) {
  const dropdownSelected = document.querySelector(dropdown);
  const contentSelectedAll = document.querySelectorAll(content);
  
  // Verifica se elementos existem antes de prosseguir
  if (!dropdownSelected || !contentSelectedAll.length) {
    console.warn(`Dropdown elements not found for selector: ${dropdown}, ${content}`);
    return;
  }
  
  // Verifica se o índice é válido
  const contentSelected = contentSelectedAll[index] || contentSelectedAll[0];
  
  if (!contentSelected) {
    console.warn(`No matching dropdown content found for index: ${index}`);
    return;
  }

  // show dropdown by clicking on navbar item
  if(dropdownSelected) {
    const dropdownIcon = dropdownSelected.querySelector('i');

    dropdownSelected.addEventListener('click', () => {
      if (dropdownIcon) {
        dropdownIcon.classList.toggle('rotate-element');
      }

      contentSelected.classList.toggle('d-flex');

      setTimeout(() => {
        contentSelected.classList.add('dropdown-active');
      }, 100);
    });

    // if dropdown active, add event to close on click outside
    document.addEventListener('click', (event) => {
      if(contentSelected.classList.contains('dropdown-active')) {
        let isClickInside = contentSelected.contains(event.target);
        let isClickOnTrigger = dropdownSelected.contains(event.target);

        if (!isClickInside && !isClickOnTrigger) {
          if (dropdownIcon) {
            dropdownIcon.classList.remove('rotate-element');
          }

          contentSelected.classList.remove('d-flex');

          setTimeout(() => {
            contentSelected.classList.remove('dropdown-active');
          }, 100);
        }
      }
    });
  }
}

// FUNCTION TO CONTROL DROPDOWNS ONLY IN SIDEBARS
export function showSidebarDropdown(dropSidebar, contentSidebar, indexSidebar) {
  const dropdownSelected = document.querySelector(dropSidebar);
  const contentSelected = document.querySelectorAll(contentSidebar);

  if(dropdownSelected) {
    const dropdownIcon = dropdownSelected.querySelector('i');

    dropdownSelected.addEventListener('click', () => {
      dropdownIcon.classList.toggle('rotate-element');
      contentSelected[indexSidebar].classList.toggle('d-flex');

      if(contentSelected[indexSidebar].classList.contains('d-flex')) {
        const dropdownHeight = contentSelected[indexSidebar].offsetHeight;

        dropdownSelected.style.cssText = `margin-bottom: calc(${dropdownHeight}px + 10px);`;
      } else {
        dropdownSelected.style.removeProperty('margin-bottom');
      }
    });
  }
}
